export const appArrowRight32Icon = {
    data: `<svg viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M10.6667 5.33331L21.3333 16.0254L10.6667 26.6666" stroke="currentColor" stroke-width="8" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/></svg>`,
    name: 'arrow-right-32'
};